var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4318ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65 3.4a2.7 2.7 0 1 1-5.4 0 2.7 2.7 0 0 1 5.4 0zM11.35 13.3a5.4 5.4 0 0 0-10.8 0zM10.45 5.2a.9.9 0 1 0 0 1.8h3.6a.9.9 0 1 0 0-1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollow);
export default __webpack_public_path__ + "static/media/unfollow.6bd8b94461d9746a5098195541a4fbbe.svg";
export { ForwardRef as ReactComponent };